// extracted by mini-css-extract-plugin
export default {"languageSelector":"styles_languageSelector__Sj0G1","helpPopup":"styles_helpPopup__C65Dx"};